import { FormControl, IconButton, InputAdornment, InputLabel, MenuItem, Select, Stack, TextField } from "@mui/material";
import { Module } from "app/modules/models/module";
import RequestControlPayments from "app/requests/components/control_payments";
import RequestControlProtocol from "app/requests/components/control_protocol";
import { Request, requestStatus, requestStatusActafoia } from "app/requests/models/request";
import { Service } from "app/services/models/service";
import { Button, Col, Icon, Table } from "design-react-kit";
import { ActaAuthContext } from "pa_kit/auth";
import Loading from "pa_kit/components/loading";
import { useContext, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import DataTable from 'react-data-table-component';


import ApiService from 'services/api';
import moment from "moment";
import RequestStatusChip from "app/requests/components/status_chip";
import RequestControlProtocolOut from "app/requests/components/control_protocol out";


export const AdminRequestListView = (props:any) => {

    const auth = useContext<any>(ActaAuthContext);
    const actagov_config = auth.organization.active_licenses?.services?.actagov;
    const sportellodigitale_config = auth.organization.active_licenses?.services?.sportellodigitale;
        
    /*










    const fetchLastRequests = async() => {
        const resutl = await ApiService.getRequests(
            props.categorySlug ?? undefined, 
            props.serviceId ?? undefined, 
            props.moduleId ?? undefined, 
            props.page ?? 1,
        );
        _setRequests(resutl);
    }

    const fetchWaitingProtocolRequests = async() => {
        const resutl = await ApiService.getWaitingProtocolRequests(
            props.categorySlug ?? undefined, 
            1,
        );
        _setRequests(resutl);
    }

    useEffect(() => {
        if(props.waitingProtocol){
            fetchWaitingProtocolRequests();
        }else{
            fetchLastRequests();

        }
    }, []);

*/



    const navigate = useNavigate();
    const params = useParams();

    const [ isLoading, _set_isLoading ] = useState(true);

    const [ requests, _set_requests ]                    = useState<Request[]>([]);
    const [ filteredRequests, _set_filteredRequests ]    = useState<Request[]>([]);
    
    const [ services, _setServices ]                    = useState<Service[]>([]);
    const [ modules, _setModules ]                      = useState<Module[]>([]);
    const [ searchKey, _set_searchKey ]                 = useState("");
    const [ searchStatusKey, _setSearchStatusKey ]      = useState("all");
    const [ searchServiceKey, _setSearchServiceKey ]    = useState("all");
    const [ searchModuleKey, _setSearchModuleKey ]      = useState("all");
    const [ searchDateFrom, _setSearchDateFrom ]        = useState<string|undefined>();
    const [ searchDateTo, _setSearchDateTo ]            = useState<string|undefined>();
    //const [ page, setPage ]    = useState(1);
    //const [ fetchPage, setFetchPage ]    = useState(1);
    
    const [ isExportEnabled, _setIsExportEnabled ]     = useState(false);
    const [ isSearchDateFromFocused, toggleSearchDateFromFocus ] = useState(false);
    const toggleSearchDateFromFocusLabel = () => toggleSearchDateFromFocus(true);
    const toggleSearchDateFromBlurLabel = (e:any) => {
        if (e.target.value === '') {
        toggleSearchDateFromFocus(!isSearchDateFromFocused);
        }
    };
    const [ isSearchDateToFocused, toggleSearchDateToFocus ] = useState(false);
    const toggleSearchDateToFocusLabel = () => toggleSearchDateToFocus(true);
    const toggleSearchDateToBlurLabel = (e:any) => {
        if (e.target.value === '') {
        toggleSearchDateToFocus(!isSearchDateToFocused);
        }
    };

    var today = new Date().toISOString().split("T")[0];

    useEffect(() => {
        _set_isLoading(true);
        fetchServices();
        fetchRequests();
    }, []);

    //useEffect(() => {
    //    fetchRequests();
    //}, [fetchPage]);

    useEffect(() => {
        //_set_isLoading(true);
        //setFetchPage(1);
        //_set_requests([]);
        _setModules([]);
        _setSearchModuleKey("all");
        services.forEach((service:Service) => {
            if(service.id == searchServiceKey) {
                //console.log(service);
                _setModules(service.modules);
            }
        });
        //fetchRequests();
    }, [searchServiceKey]);

    useEffect(() => {
        //_set_isLoading(true);
        //setFetchPage(1);
        //_set_requests([]);
        modules.forEach((module:Module) => {
            if(module.id == searchModuleKey) {
                _setIsExportEnabled(module.exportEnabled);
            }
        });
        //fetchRequests();
    }, [searchModuleKey]);

    useEffect(() => {

        let newFilteredRequests = [...requests];

        if(searchKey != ""){
            newFilteredRequests = newFilteredRequests.filter((element:Request) => {
                const elementString = element.module.name + " " + element.id + " " + element.user.first_name + " " + element.user.last_name;
                
                for(let searchKeyPart of searchKey.split(" ")){
                    if(!elementString.toLowerCase().includes(searchKeyPart.toLowerCase())){
                        return false;
                    }
                }
                return true;
            });
        }

        if(searchServiceKey != "all"){
            newFilteredRequests = newFilteredRequests.filter((element:Request) => element.module.service.id == searchServiceKey);
        }
        if(searchModuleKey != "all"){
            newFilteredRequests = newFilteredRequests.filter((element:Request) => element.module.id == searchModuleKey);
        }
        if(searchStatusKey != "all"){
            newFilteredRequests = newFilteredRequests.filter((element:Request) => element.status == searchStatusKey);
        }

        //filteredRequests = requests.filter((request:Request) => ((searchStatusKey == "all" || request.status == searchStatusKey) &&
        //(searchKey == "" || (request.module.name as string).toLowerCase().includes(searchKey?.toLowerCase() ?? "") || (request.id as string).toLowerCase().includes(searchKey?.toLowerCase() ?? ""))));

        _set_filteredRequests(newFilteredRequests);
    }, [requests, searchServiceKey, searchModuleKey, searchStatusKey, searchKey]);


    const fetchServices = async () => {
        var responseData = await ApiService.getServices();
        _setServices(responseData);
    }

    const exportCsv = () => {
        var exportUrl = sportellodigitale_config.backend_url + 'api/modules/' + searchModuleKey + '/export_requests?';
        if(searchDateFrom) exportUrl += 'from=' + searchDateFrom + '&';
        if(searchDateTo) exportUrl += 'to=' + searchDateTo + '&';
        console.log('redirecting to:', [exportUrl])
        window.open( exportUrl, '_blank');
    }

    const fetchRequests = async () => {
        let result:Request[] = await ApiService.getRequests(
            undefined, //params.categorySlug,
            undefined, //searchKey !== "" ? searchKey : undefined,
            undefined, //searchServiceKey !== "all" ? searchServiceKey : undefined, 
            undefined, //searchModuleKey !== "all" ? searchModuleKey : undefined, 
            props.waitingProtocol,
            -1, //fetchPage,
        );
        
        _set_requests(props.full ? result : result.slice(0, 5));
        _set_isLoading(false);
    }


    const paginationOptions = {
        rowsPerPageText: 'Elementi per pagina',
        rangeSeparatorText: 'di',
        selectAllRowsItem: false,
        //selectAllRowsItemText: 'Tutti',
    }

    const columns = [
        {
            name: 'Modulo',
            selector: (row:any) => row.module.name,
            sortable: true,
            cell: (row:any) => ( <Link to={"/admin/requests/" + row.id}>{ row.module.name }</Link> ),
            //width: "150px"
        },
        {
            name: 'Richiedente',
            selector: (row:any) => row.user["first_name"] + " " + row.user["last_name"],
            sortable: true,
            cell: (row:any) => ( row.user["first_name"] + " " + row.user["last_name"] ),
            //width: "150px"
        },
        {
            name: 'Data richiesta ',
            selector: (row:any) => row.created,
            sortable: true,
            cell: (row:any) => ( moment(row.created).format('DD/MM/YY') ),
            width: "150px"
        },
        ( props.waitingProtocol ?
            {
                name: 'Data invio PEC',
                selector: (row:any) => row.protocolSent,
                sortable: true,
                cell: (row:any) => ( moment(row.protocolSent).format('DD/MM/YY HH:mm') ),
                width: "150px"
            } : 
            {
                name: 'Data ultimo aggiornamento',
                selector: (row:any) => row.lastUpdate,
                sortable: true,
                cell: (row:any) => ( moment(row.lastUpdate).format('DD/MM/YY HH:mm') ),
                width: "200px"
            }
        ),
        {
            name: 'Stato',
            //selector: (row:any) =>,
            sortable: false,
            cell: (row:any) => ( <RequestStatusChip key={"request_" + row.id + "_status"} request={row} /> ),
            //width: "150px"
        },
        {
            name: 'Pagamenti',
            //selector: (row:any) =>,
            sortable: false,
            cell: (row:any) => (<RequestControlPayments key={"request_" + row.id + "_payment"} request={row} /> ),
            width: "100px"
        },
        {
            name: 'Protocollo (in/out)',
            //selector: (row:any) =>,
            sortable: false,
            cell: (row:any) => ( 
                <div className="d-flex gap-2">
                    <RequestControlProtocol key={"request_" + row.id + "_protocol"} request={row} />
                    <RequestControlProtocolOut key={"request_" + row.id + "_protocol_out"} request={row} />
                </div> ),
            //width: "150px"
        },
        {
            name: 'Azioni',
            button: true,
            cell: (row:any) => (
                <IconButton key={"request_" + row.id + "_download"} color="primary" href={row.getLastUpdatePdfUrl(sportellodigitale_config)} target="_blank">
                    <Icon icon="it-download" />
                </IconButton> 
            )
        }
    ];


    return (
        <div className="admin-card">
            <div className="admin-card-header">
                <div className="admin-card-icon admin-card-icon-news black-gradient">
                    {props.waitingProtocol ? (
                        <Icon color='white' icon='it-warning-circle' size='lg'/>
                    ):(
                        <Icon color='white' icon='it-inbox' size='lg'/>
                    )}
                </div>
                <p><small>
                    {props.waitingProtocol ? (
                        <>
                            {props.full ? (
                                <>Tutte le pratiche da protocollare</>
                            ):(
                                <>Utime pratiche da protocollare</>
                            )}
                        </>
                    ):(
                        <>
                            {props.full ? (
                                <>Tutte le pratiche ricevute</>
                            ):(
                                <>Ultime pratiche ricevute</>
                            )}
                        </>
                    )}
                </small></p>
            </div>
            <hr className="divider-dark mb-0" />

            <div className="admin-card-content px-4">
                {props.full && (
                <Col>
                    <FormControl  sx={{ alignItems: 'flex-start', marginBottom: 4, width: "100%" }}>
                        <InputLabel>Servizio</InputLabel>
                        <Select value={searchServiceKey} label="Servizio" onChange={(event:any) => _setSearchServiceKey(event.target.value)} sx={{ width: "100%", }} >
                            <MenuItem key="service_menuitem_all" value="all">Tutti</MenuItem>
                            { services.map((service:Service) => service.modules.length > 0 && (
                                <MenuItem key={"service_menuitem_" + service.id} value={service.id}>{service.name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    {searchServiceKey !== "all" && (
                        <FormControl  sx={{ alignItems: 'flex-start', marginBottom: 4, width: "100%" }}>
                            <InputLabel>Modulo</InputLabel>
                            <Select value={searchModuleKey} label="Modulo" onChange={(event:any) => _setSearchModuleKey(event.target.value)} sx={{ width: "100%", }} >
                                <MenuItem key="module_menuitem_all" value="all">Tutti</MenuItem>
                                { modules.map((module:Module) =>
                                    <MenuItem key={"module_menuitem_" + module.id} value={module.id}>{module.name}</MenuItem>
                                )}
                            </Select>
                        </FormControl>
                    )}

                    { false && searchModuleKey !== "all" && isExportEnabled && (
                        <Stack direction="row" gap={2} marginBottom={2}>
                            <div className='form-group flex-grow-1'>
                                <div className='input-group'>
                                    <label htmlFor='input-group-1' className={searchDateFrom || isSearchDateFromFocused || true ? 'active' : ''}>
                                        Esporta pratiche dal
                                    </label>
                                    <input
                                        type='date'
                                        className={isSearchDateFromFocused || true ? 'form-control focus--mouse' : 'form-control'}
                                        onFocus={toggleSearchDateFromFocusLabel}
                                        onBlur={toggleSearchDateFromBlurLabel}
                                        name="searchDateFrom" id="searchDateFrom"
                                        value={searchDateFrom}
                                        max={searchDateTo ?? today}
                                        onChange={(event) => _setSearchDateFrom(event.target.value)}
                                        
                                    />
                                </div>
                            </div>
                            <div className='form-group flex-grow-1'>
                                <div className='input-group'>
                                    <label htmlFor='input-group-1' className={searchDateTo || isSearchDateToFocused || true ? 'active' : ''}>
                                        Esporta pratiche fino al
                                    </label>
                                    <input
                                        type='date'
                                        className={isSearchDateToFocused || true ? 'form-control focus--mouse' : 'form-control'}
                                        onFocus={toggleSearchDateToFocusLabel}
                                        onBlur={toggleSearchDateToBlurLabel}
                                        name="searchDateTo" id="searchDateTo"
                                        value={searchDateTo}
                                        min={searchDateFrom}
                                        max={today}
                                        onChange={(event) => _setSearchDateTo(event.target.value)}
                                        
                                    />
                                </div>
                            </div>
                            <Button data-element="service-file" style={{ height: 45 }} color='primary' onClick={()=> exportCsv()}>Esporta .CSV</Button>
                        </Stack>
                    )}



                    <div id="requests_list_search_field" style={{ display: "flex", gap: 4, alignItems: "stretch" }}>
                        <TextField label="Cerca..." variant="outlined" value={searchKey} onChange={(event:any) => _set_searchKey(event.target.value)} size="medium" sx={{ flexGrow: 1, height: "100%" }}
                            InputProps={{
                                startAdornment: <InputAdornment position="start">
                                        <Icon icon="it-search" />
                                    </InputAdornment>
                            }}
                        />

                        <FormControl sx={{ width: 250, alignItems: 'flex-start', height: "100%" }}>

                            <InputLabel>Status</InputLabel>
                                {sportellodigitale_config.actafoia_enabled ? (
                                    <Select value={searchStatusKey} label="Status" onChange={(event:any) => _setSearchStatusKey(event.target.value)} sx={{ width: 250 }} >
                                        <MenuItem value="all">Tutti</MenuItem>
                                        { Object.keys(requestStatusActafoia).map((key, index) =>
                                            <MenuItem value={key}>{requestStatusActafoia[key as keyof typeof requestStatusActafoia]?.label}</MenuItem>
                                        )}
                                    </Select>
                                ):(
                                    <Select value={searchStatusKey} label="Status" onChange={(event:any) => _setSearchStatusKey(event.target.value)} sx={{ width: 250 }} >
                                        <MenuItem value="all">Tutti</MenuItem>
                                        { Object.keys(requestStatus).map((key, index) =>
                                            <MenuItem value={key}>{requestStatus[key as keyof typeof requestStatus]?.label}</MenuItem>
                                        )}
                                    </Select>
                                )}
                        </FormControl>

                        {/*
                        <Button color='primary' size="lg">SCARICA .CSV</Button>
                        */}
                    </div>
                </Col>
                )}



                {isLoading ? (
                    <div style={{ width: "100%", textAlign: "center" }}><Loading /></div>
                ):(
                    <>
                        <DataTable
                            columns={columns}
                            data={filteredRequests}
                            pagination
                            paginationComponentOptions={paginationOptions}
                            paginationPerPage={30}
                            defaultSortFieldId={3}
                            progressPending={isLoading}
                            progressComponent={<div className="pb-5 pt-5"><Loading /></div>}
                            defaultSortAsc={false}
                        />
                        <a href="/admin/events" className="admin-link admin-card-view-more">
                            Visualizza tutti
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-right" viewBox="0 0 16 16">
                                <path fillRule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"/>
                            </svg>
                        </a>
                        { !props.full && (
                            <a href={props.waitingProtocol ? "/admin/requests-waiting-protocol" : "/admin/requests"} className="admin-link admin-card-view-more">
                                Visualizza tutti
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-right" viewBox="0 0 16 16">
                                    <path fillRule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"/>
                                </svg>
                            </a>
                        )}
                    </>
                )}
            </div>
        </div>

    );

}